<template>
  <Breadcrumb></Breadcrumb>
  <div class="px-4 sm:px-0" v-if="rentalListingAgreement">
    <div class="grid grid-cols-3">
      <div class="col-span-2">
        <div class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow m-4">
          <div class="px-4 py-5 sm:p-6">
            <div class="flex gap-2 items-center">
              <div class="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center">
                <BriefcaseIcon class="h-8 w-8 text-gray-700"></BriefcaseIcon>
              </div>
              <RentalListingAgreementId :rentalListingAgreement="rentalListingAgreement" />
              <div class="p-2">
                <RiskScoringLabel :level="riskScoring?.attributes?.scoreLevel ?? undefined" />
              </div>
              <router-link class="p-2 text-indigo-600 hover:text-indigo-900 ml-auto" :to="{ name: 'edit-rental-listing-agreement', params: { id: rentalListingAgreement.id } }">
                {{ $gettext("Editer") }}<span class="sr-only">, {{ rentalListingAgreement.id }}</span>
              </router-link>
            </div>
          </div>
        </div>
        <div class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow m-4">
          <RiskScoringFactorList v-if="riskScoring" :riskScoring="riskScoring" :riskScoringStore="riskScoringStore" @updated="handleRiskScoringUpdate"/>
        </div>
      </div>
      <div class="col-span-1">
        <div class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow col-span-1 m-4">
          <div class="px-4 py-5 sm:px-6">
            <span class="text-xl font-semibold text-gray-900">{{ $gettext("Aperçu") }}</span>
          </div>
          <RiskScoringChart v-if="riskScoring" :riskScoring="riskScoring" />
        </div>
        <div class="divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow col-span-1 m-4">
          <div class="px-4 py-5 sm:px-6" v-if="riskScoring">
            <SanctionsBox v-if="riskScoring" :riskScoring="riskScoring" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { ref } from "vue";
import { useRentalListingAgreementStore } from "@/stores/rentalListingAgreement.js";
import { useRoute } from "vue-router";
import RiskScoringLabel from "@/components/risk-scorings/RiskScoringLabel.vue";
import RiskScoringFactorList from "@/components/risk-scorings/RiskScoringFactorList.vue";
import { BriefcaseIcon } from "@heroicons/vue/24/outline";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import { useRiskScoring } from "@/stores/riskScoring";

import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from "echarts/components";
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";
import RiskScoringChart from "@/components/risk-scorings/RiskScoringChart.vue";
import SanctionsBox from "@/components/risk-scorings/SanctionsBox.vue";
import RentalListingAgreementId from "@/components/rental-listing-agreements/RentalListingAgreementId.vue"

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
]);

const route = useRoute();
const rentalListingAgreementId = route.params.id;
const rentalListingAgreementStore = useRentalListingAgreementStore();
const rentalListingAgreement = ref(null);

const riskScoringStore = useRiskScoring("rental-listing-agreements", rentalListingAgreementId);

onMounted(async () => {
  rentalListingAgreement.value = await rentalListingAgreementStore.fetchOne(rentalListingAgreementId, null, ["lastRiskScoring"]);
});

const riskScoring = ref(null);

const loadRentalListingsAgreement = async () => {
  rentalListingAgreement.value = await rentalListingAgreementStore.fetchOne(rentalListingAgreementId, null, ["lastRiskScoring"]);
}

const handleRiskScoringUpdate = async () => {
  await loadRentalListingsAgreement();
  let riskScoringId = rentalListingAgreement.value.relationships.lastRiskScoring.data.id
  riskScoring.value = await riskScoringStore.fetchOne(riskScoringId);
};

onMounted(async () => {
  await loadRentalListingsAgreement();
  let riskScoringId = rentalListingAgreement.value.relationships.lastRiskScoring.data.id
  riskScoring.value = await riskScoringStore.fetchOne(riskScoringId);
});

</script>
